import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../store/useAppStore';

export function AuthForm() {
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const signIn = useAppStore(s => s.signIn);
  const signUp = useAppStore(s => s.signUp);
  const signOut = useAppStore(s => s.signOut);
  const user = useAppStore(s => s.user);
  const authLoading = useAppStore(s => s.authLoading);  
  const authError = useAppStore(s => s.authError);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const ok = mode === 'login'
      ? await signIn(email, password)
      : await signUp(email, password, username);
    if (ok) navigate('/', { replace: true });
  };

  if (user) {
    return (
      <div className="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow mb-6">
        <span className="text-gray-700 mb-2">Zalogowano jako <b>{user.email}</b></span>
        <button
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          onClick={signOut}
        >
          Wyloguj
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="max-w-sm mx-auto bg-white rounded-lg shadow p-6 mb-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
        {mode === 'login' ? 'Logowanie' : 'Rejestracja'}
      </h2>
      <div className="mb-4">
        <label className="block text-gray-700 mb-1">Email</label>
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
          required
        />
      </div>
      {mode === 'register' && (
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Username</label>
          <input
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
            required
          />
        </div>
      )}
      <div className="mb-4">
        <label className="block text-gray-700 mb-1">Hasło</label>
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
          required
        />
      </div>
      {authError && <div className="text-red-600 text-sm mb-2 text-center">{authError}</div>}
      <button
        type="submit"
        className="w-full py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors disabled:opacity-50"
        disabled={authLoading}
      >
        {authLoading ? '...' : mode === 'login' ? 'Zaloguj się' : 'Zarejestruj się'}
      </button>
      <div className="text-center mt-4">
        <button
          type="button"
          className="text-blue-600 hover:underline text-sm"
          onClick={() => setMode(mode === 'login' ? 'register' : 'login')}
        >
          {mode === 'login' ? 'Nie masz konta? Zarejestruj się' : 'Masz już konto? Zaloguj się'}
        </button>
      </div>
    </form>
  );
}
